module.exports = __webpack_public_path__ + "img/syzxp02.2a677046.png";